import opportunity from ".";
import * as types from "./types";

const mutations = {
    [types.LOADING_OPPORTUNITIES](state, value) {
        state.loading = value;
    },
    [types.GET_OPPORTUNITIES_LIST](state, opportunities) {
        state.opportunities = opportunities;
    },
    [types.REMOVE_OPPORTUNITIES](state, id) {
        state.opportunities = state.opportunities.filter((x) => x.id !== id);
    },
    [types.ADD_OPPORTUNITIES](state, opportunity) {
        state.opportunities.unshift(opportunity);
        state.newOpporuntity = opportunity;
    },
    [types.UPDATE_OPPORTUNITIES](state, opportunity) {
        const opportunityIndex = state.opportunities.findIndex((x) => x.id === opportunity.id);
        state.opportunities[opportunityIndex] = opportunity;
    },
    [types.GET_OPPORTUNITY_ID](state, opportunityId) {
        state.opportunityId = opportunityId;
    },
    [types.UPDATE_OPPORTUNITY_STATUS](state, payload) {
        const opportunityIndex = state.opportunities.findIndex((x) => x.id === payload.id);
        if (opportunityIndex !== -1) {
            state.opportunities[opportunityIndex].status = payload.status;
        }
    },

    [types.GET_PIPELINES_LIST](state, pipelines) {
        state.pipelines = pipelines;
    }
};

export default mutations;